module.exports = __webpack_public_path__ + "img/Singing and the Actor.fb5eb27b.jpg";